import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "footer": null,
      "width": 650,
      "data-sign": "pay_account_detail_modal",
      "title": _vm.t('付款账户详情')
    },
    model: {
      value: _vm.modalVisible,
      callback: function ($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7B7E\u7EA6\u4E3B\u4F53\u540D\u79F0"),
      "label": _vm.t('签约主体名称')
    }
  }, [_c('my-operation', [_vm._v(" " + _vm._s(_vm.detailData.sign_body_name) + " ")])], 1), _c('a-form-model', [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u7B2C\u4E09\u65B9\u5E73\u53F0"),
      "label": _vm.t('是否第三方平台')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.isthird_party === String(_vm.$enum.common.BoolIntEnum.NO) ? _vm.t('否') : _vm.detailData.isthird_party === String(_vm.$enum.common.BoolIntEnum.YES) ? _vm.t('是') : '')) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u7B2C\u4E09\u65B9\u652F\u4ED8")
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('是否第三方支付')))]), _c('a-tooltip', {
    attrs: {
      "placement": "top",
      "title": _vm.t('付款账户的开户主体与签约主体不一致。')
    }
  }, [_c('a-icon', {
    staticClass: "ml-5",
    staticStyle: {
      "vertical-align": "middle !important"
    },
    attrs: {
      "type": "question-circle"
    }
  })], 1)], 1), _vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.is_unofficial_text)) + " ")], 2), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u94F6\u884C\u540D\u79F0"),
      "label": _vm.t('银行名称')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.pay_bank_name)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8D26\u6237\u7F16\u53F7"),
      "label": _vm.t('账户编号')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.account_code)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5F00\u6237\u884C\u56FD\u5BB6/\u5730\u533A"),
      "label": _vm.t('开户行国家/地区')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.open_bank_country_name)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5F00\u6237\u884C\u540D\u79F0"),
      "label": _vm.t('开户行名称')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.open_bank_name)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8054\u884C\u53F7"),
      "label": _vm.t('联行号')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.payment_lines)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5883\u5185\u6C47\u6B3E\u4EE3\u7801"),
      "label": _vm.t('境内汇款代码')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.bsb_code)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name":
      /*no-i18n-auto*/
      'Swift Code',
      "label": _vm.t('Swift Code')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.swift_code)) + " ")]), _vm.detailData.payee_info ? [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u56FD\u5BB6/\u5730\u533A"),
      "label": _vm.t('付款方国家/地区')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.payee_info.country_name)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u7701/\u5DDE"),
      "label": _vm.t('付款方省/州')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.payee_info.province_name)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u57CE\u5E02"),
      "label": _vm.t('付款方城市')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.payee_info.city_name)) + " ")]), _vm.isNeedPayeeCaAddress(_vm.detailData) ? [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u8857\u9053\u540D"),
      "label": _vm.t('付款方街道名')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.payee_info.street)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u5EFA\u7B51\u53F7"),
      "label": _vm.t('付款方建筑号')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.payee_info.building_no)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u90AE\u7F16"),
      "label": _vm.t('付款方邮编')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.payee_info.postal_code)) + " ")])] : _vm._e()] : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5E01\u79CD"),
      "label": _vm.t('币种')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.currency_codes && _vm.detailData.currency_codes.join(','))) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u53D7\u6258\u5173\u7CFB")
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('受托关系')))]), _c('a-tooltip', {
    attrs: {
      "placement": "top",
      "title": _vm.t('委托人与受托人关系。')
    }
  }, [_c('a-icon', {
    staticClass: "ml-5",
    staticStyle: {
      "vertical-align": "middle !important"
    },
    attrs: {
      "type": "question-circle"
    }
  })], 1)], 1), _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.detailData.fiduciary_text)))]), _vm.detailData.fiduciary === _vm.$enum.finance.PaymentAccountFiduciaryEnum.OTHER && _vm.detailData.fiduciary_desc ? _c('span', [_vm._v(_vm._s(_vm.tc('：')) + _vm._s(_vm.detailData.fiduciary_desc))]) : _vm._e()], 2), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u59D4\u6258\u4ED8\u6B3E\u51FD"),
      "label": _vm.t('委托付款函')
    }
  }, [_vm.detailData.preview_url ? _c('a', {
    attrs: {
      "download": "",
      "data-sign": "pay_account_download_preview_url",
      "target": "_blank",
      "href": _vm.detailData.preview_url,
      "fbu-analyse-name": $t("\u4E0B\u8F7D")
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "download"
    }
  }), _vm._v(_vm._s(_vm.t('下载')) + " ")], 1) : _c('span', [_vm._v("--")])]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u514D\u8D23\u58F0\u660E"),
      "label": _vm.t('免责声明')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.accept_text)) + " ")])], 2)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };